import React, { Component } from "react";
import { slide as Menu } from "react-burger-menu";
import {TYPE_NEXT_SAVE, URL_SERVER_UPT} from "../../const";
import ButtonPurchase from "../Button/ButtonPurchase";
import ButtonBackUpt from "../Button/ButtonBackUpt";
import ButtonEdit from "../Button/ButtonEdit";

export default class SideBarHeader extends Component {

  handleStateChange(state) {
    let {
      handleUpdateState,
    } = this.props;

    handleUpdateState('isShowHamburger', state.isOpen)
  }

  render() {
    return (
      <Menu isOpen={this.props.isShowHamburger} onStateChange={(state) => this.handleStateChange(state)}>
      <div className="mobile-navigation">
        <div className="head">
          <div className="aside"></div>
          <a href={URL_SERVER_UPT}>
            <img src="/img/logo-s.png" alt="UP-T" className="logo"/>
          </a>
          </div>
        <div className="content">
          <ButtonEdit {...this.props} />
          <ButtonPurchase {...this.props} typeButtonSave = {TYPE_NEXT_SAVE} />
        </div>
      </div>
      </Menu>
    );
  }
}
